import React from 'react';
import PropTypes from 'prop-types';
import CategoryToolTile from './CategoryToolTile';
import { find } from 'lodash';

const StaffPicks = props => {
  const {
    content = {},
    fptiImpression,
    fptiClick,
    toolTileProps,
    structuredPSData
  } = props;
  const { staffPickDisplayed = [] } = structuredPSData;
  const { flatPSData: { tools = {}, categories = {} } = {} } = toolTileProps;

  const categoriesArr = Object.values(categories);

  const toolsArr = Object.values(tools);

  const handleClickTool = ({
    fptiLink,
    prod,
    PSUrl,
    categoryRank,
    appKey,
    rank,
    priorityScore
  }) => {
    return () => {
      fptiClick({
        fptiLink,
        prod,
        pageLink: content.categoryFPTI,
        type: 'paypal_picks',
        categoryRank,
        appKey,
        rank,
        priorityScore
      });
      fetch(PSUrl);
    };
  };

  return (
    <div id="appcenter-categories">
      <div className="appcenter-category">
        <div className="category-header">
          <h3>{content.categoryTitle}</h3>
        </div>
        <div className="category-row">
          {staffPickDisplayed.map(sortedTool => {
            const staffPickTool =
              find(toolsArr, obj => obj.appKey === sortedTool.appKey) || {};
            const staffPickCategory = find(
              categoriesArr,
              obj => obj.categoryKey === staffPickTool.categoryKey
            );
            if (staffPickCategory === undefined) return null;
            return (
              <CategoryToolTile
                fptiImpression={fptiImpression}
                tool={staffPickTool}
                toolTileProps={toolTileProps}
                path={`/appcenter/${staffPickCategory.location}`}
                handleClickTool={handleClickTool}
                hideFavorites={false}
                staffPickType="paypal_picks"
                pageLink={content.categoryFPTI}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

StaffPicks.propTypes = {
  content: PropTypes.object,
  structuredPSData: PropTypes.object,
  toolTileProps: PropTypes.object,
  fptiImpression: PropTypes.func,
  fptiClick: PropTypes.func
};

export default StaffPicks;
